"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIframePidgetLocation = void 0;
var react_1 = require("react");
var useIframePidgetLocation = function (workspaceUrl) {
    var _a = react_1.useState(), iframePidgetLocation = _a[0], setIframePidgetLocation = _a[1];
    react_1.useEffect(function () {
        if (iframePidgetLocation) {
            var message = {
                title: iframePidgetLocation.title,
                type: "LocationChanged",
                url: iframePidgetLocation.url
            };
            window.parent.postMessage(JSON.stringify(message), workspaceUrl);
        }
    }, [iframePidgetLocation, workspaceUrl]);
    return { setIframePidgetLocation: setIframePidgetLocation };
};
exports.useIframePidgetLocation = useIframePidgetLocation;
